import { render, staticRenderFns } from "./BannerBackground.vue?vue&type=template&id=4bde69e6&"
import script from "./BannerBackground.vue?vue&type=script&lang=js&"
export * from "./BannerBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports